import { useState, useRef, useEffect } from 'react'

/**
 * Manages share drag-and-drop reorg between folders.
 * Owns the invisible drag image element and drag state.
 */
export function useDragAndDrop() {
  const [draggingShareId, setDraggingShareId] = useState<string | null>(null)
  const [dragOverFolderPath, setDragOverFolderPath] = useState<string | null>(null)
  const dragImageRef = useRef<HTMLDivElement | null>(null)

  // Create an invisible 1x1 drag image to replace the default browser ghost
  useEffect(() => {
    const el = document.createElement('div')
    el.style.width = '1px'
    el.style.height = '1px'
    el.style.position = 'fixed'
    el.style.top = '-1000px'
    el.style.opacity = '0.01'
    document.body.appendChild(el)
    dragImageRef.current = el
    return () => {
      document.body.removeChild(el)
      dragImageRef.current = null
    }
  }, [])

  const handleDragEnd = () => {
    setDraggingShareId(null)
    setDragOverFolderPath(null)
  }

  return {
    draggingShareId,
    setDraggingShareId,
    dragOverFolderPath,
    setDragOverFolderPath,
    dragImageRef,
    handleDragEnd,
  }
}
